import { productRealPrice } from "../price/price.util";
import { skuProductItem } from "../product/product.util";
import { TrackTypes } from "./track";

declare const window: any;

const validateEventData = (event: TrackTypes, data: Record<string, any>): boolean => 
{
    switch (event) 
    {
        case TrackTypes.ViewContent:
        case TrackTypes.AddToCart:
        case TrackTypes.AddToWishlist:
            if (!data.product) 
            {
                console.error(`[TikTok Track] Missing product data for event ${event}`);
                return false;
            }

            if (!data.product.id && !data.variant) 
            {
                console.error(`[TikTok Track] Missing product.id and variant for event ${event}`);
                return false;
            }

            return true;

        case TrackTypes.InitiateCheckout:
        case TrackTypes.AddPaymentInfo:
            if (!Array.isArray(data.cart?.items) || data.cart.items.length === 0) 
            {
                console.error(`[TikTok Track] Missing or empty cart.items for event ${event}`);
                return false;
            }

            return true;

        case TrackTypes.Purchase:
            if (!Array.isArray(data.order?.items) || data.order.items.length === 0) 
            {
                console.error(`[TikTok Track] Missing or empty order.items for event ${event}`);
                return false;
            }

            if (!data.order.id) 
            {
                console.error(`[TikTok Track] Missing order.id for event ${event}`);
                return false;
            }

            return true;

        default:
            return true;
    }
};

export const tiktokTrack = (eventId: string, externalId:string, event: TrackTypes, data: Record<string, any> = {}) => 
{
    if (typeof window === "undefined" || typeof window.ttq?.track !== "function") return;
    if (!validateEventData(event, data)) return;

    let eventData: any;

    const getContentsFromProduct = () => 
    {
        const sku = skuProductItem(data?.product, data?.variant);
        return [
            {
                content_id   : sku,
                content_type : "product",
                quantity     : data?.quantity || 1,
                price        : productRealPrice(data?.product, data?.variant, false),
            },
        ];
    };

    switch (event) 
    {
        case TrackTypes.ViewContent:
        case TrackTypes.AddToCart:
        case TrackTypes.AddToWishlist: 
            const price = productRealPrice(data?.product, data?.variant, false);
            const quantity = data?.quantity || 1;
            eventData = {
                content_id   : data?.product?.id || skuProductItem(data?.product, data?.variant),
                content_type : "product",
                content_name : data?.product?.name,
                quantity, 
                price,
                value        : price * quantity,
                currency     : "BRL",
                contents     : getContentsFromProduct(),
                event_id     : eventId,
            };
            window.ttq.track(event, eventData); 
            break;

        case TrackTypes.Search:
            eventData = {
                search_string : data?.term || "",
                event_id      : eventId,
            };
            window.ttq.track("Search", eventData);
            break;

        case TrackTypes.PageView:
            // Envie apenas se o pixel estiver configurado para `autoTracking: false`
            eventData = { event_id : eventId };
            window.ttq.track("PageView", eventData);
            break;

        case TrackTypes.CompleteRegistration:
        case TrackTypes.Lead:
            eventData = {
                content_name : "Cadastro no site",
                status       : "success",
                value        : 0,
                currency     : "BRL",
                event_id     : eventId,
            };
            window.ttq.track(event, eventData);
            break;

        case TrackTypes.InitiateCheckout:
        case TrackTypes.AddPaymentInfo: 
            const checkoutItems = data.cart.items.map((item: any) => ({
                content_id   : item.id,
                content_type : "product",
                quantity     : item.quantity,
                price        : item.price,
            }));

            eventData = {
                contents     : checkoutItems,
                value        : data.cart.total || 0,
                currency     : "BRL",
                payment_type : data.cart.paymentMethod?.value || "",
                event_id     : eventId,
            };
            window.ttq.track(event, eventData);
            break;

        case TrackTypes.Purchase: {
            const purchaseItems = data.order.items.map((item: any) => ({
                content_id   : item.id,
                content_type : "product",
                quantity     : item.quantity,
                price        : item.price,
            }));

            eventData = {
                contents       : purchaseItems,
                value          : data.order.total || 0,
                currency       : "BRL",
                payment_type   : data.order.paymentMethod?.value || "",
                transaction_id : data.order.id,
                event_id       : eventId,
            };
            window.ttq.track("Purchase", eventData);
            break;
        }

        default:
            break;
    }

    return eventData;
};